import httpStore from "@/api/httpStore.js";

export function getBulkRows(uploadId, validFilter = null, page = null, perPage = 100, errorText = null) {
  const params = validFilter !== null ? { valid: validFilter ? 1 : 0 } : {};
  if (page !== null) {
    params.page = page;
    params.per_page = perPage;
  }
  if (errorText) params.error = errorText;
  return httpStore
    .get(`/bulk_products/rows/${uploadId}`, { params })
    .then(res => res.data)
    .catch(e => { throw e; });
}

// Aplica field=value a TODAS las filas del upload (opcionalmente filtradas por
// is_valid), sin depender de qué página tenga cargada el grid en memoria.
export function bulkUpdateRows(uploadId, field, value, validFilter = null) {
  const body = { field, value };
  if (validFilter !== null) body.valid = validFilter ? 1 : 0;
  return httpStore
    .put(`/bulk_products/rows_bulk/${uploadId}`, body)
    .then(res => res.data)
    .catch(e => { throw e; });
}

export function getBulkErrorSummary(uploadId) {
  return httpStore
    .get(`/bulk_products/rows_errors_summary/${uploadId}`)
    .then(res => res.data)
    .catch(e => { throw e; });
}

// El endpoint requiere el header de auth (no acepta token por query string),
// así que no se puede abrir como un link directo: hay que pedirlo como blob
// con httpStore (que ya manda el header) y disparar la descarga a mano.
export function downloadBulkRowsCsv(uploadId, validFilter = null, errorText = null) {
  const params = validFilter !== null ? { valid: validFilter ? 1 : 0 } : {};
  if (errorText) params.error = errorText;
  return httpStore
    .get(`/bulk_products/rows_export/${uploadId}`, { params, responseType: "blob" })
    .then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      const suffix = validFilter === false ? "_errors" : "";
      link.setAttribute("download", `bulk_product_upload_${uploadId}${suffix}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch(e => { throw e; });
}

export function updateBulkRow(rowId, data) {
  return httpStore
    .put(`/bulk_products/rows/${rowId}`, data)
    .then(res => res.data)
    .catch(e => { throw e; });
}

export function generateBulkCodes(uploadId, prefix, startFrom = 1) {
  return httpStore
    .post(`/bulk_products/generate_codes`, { upload_id: uploadId, prefix, start_from: startFrom })
    .then(res => res.data)
    .catch(e => { throw e; });
}

export function validateBulkUpload(uploadId) {
  return httpStore
    .post(`/bulk_products/validate/${uploadId}`)
    .then(res => res.data)
    .catch(e => { throw e; });
}

export function commitBulkUpload(uploadId) {
  return httpStore
    .post(`/bulk_products/commit/${uploadId}`)
    .then(res => res.data)
    .catch(e => { throw e; });
}
